import { injectable, inject } from 'inversify'

import { RequestTracker, type RequestTrackInfo } from './RequestTracker'

@injectable()
export class AbortRequestController {
  constructor(
    @inject(RequestTracker)
    protected readonly $requestTracker: RequestTracker,
  ) {}

  private heavyAbortableMethods: Set<string> = new Set()
  private redirectAbortableMethods: Set<string> = new Set()

  registerHeavyAbortableMethods(methodsKeys: string[]) {
    methodsKeys.forEach(key => this.heavyAbortableMethods.add(key))
  }

  registerRedirectAbortableMethods(methodsKeys: string[]) {
    methodsKeys.forEach(key => this.redirectAbortableMethods.add(key))
  }

  abortRedirectMethods() {
    if (import.meta.server) {
      return
    }

    const abortableRequests = this.$requestTracker
      .getAllRequests()
      .filter(r => this.redirectAbortableMethods.has(r.methodKey))

    for (const request of abortableRequests) {
      this.abortMethod(request)
    }
  }

  abortSameMethods(request: RequestTrackInfo) {
    if (import.meta.server) {
      return
    }

    const abortableRequests = this.$requestTracker
      .getAllRequests()
      .filter((r) => {
        return (
          r.methodKey === request.methodKey
          && r.id !== request.id
          && this.heavyAbortableMethods.has(r.methodKey)
        )
      })

    for (const request of abortableRequests) {
      this.abortMethod(request)
    }
  }

  abortMethod(request: RequestTrackInfo) {
    request?.abort?.()
  }
}
